import React, { Component } from "react";
import PropTypes from 'prop-types';
import Select from 'react-select';

class TagListEditor extends Component {
  static propTypes = {
    defaultValue: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    onPreviewEditEnd: PropTypes.func,
    availableTags: PropTypes.any,
    disable: PropTypes.bool,
    preview: PropTypes.bool,
    required: PropTypes.bool,
  };

  static defaultProps = {
    availableTags: [],
    disable: false,
    preview: false,
    required: false
  };

  constructor(props) {
    super(props);

    this.selectRef = React.createRef();

    // create a list of tags grouped that react-select can understand
    const availableTags = props.availableTags
      .sort((a, b) =>
        a.tagTypeRefId.localeCompare(b.tagTypeRefId) || a.name.localeCompare(b.name)
      )
      .filter((a) => this.props.availableTags.find((b) => b.tagTypeRefId === a.tagTypeRefId) === a)
      .map((tagGroup) => ({
        label: tagGroup.tagTypeRef.name,
        tagTypeId: tagGroup.tagTypeRefId,
        options: props.availableTags
          .filter((tag) => tag.tagTypeRefId === tagGroup.tagTypeRefId)
          .map((tag) => ({
            value: tag.tagRefId,
            label: tag.name,
            tagTypeId: tagGroup.tagTypeRefId
          }))
      }));

    // create selected tags array by reference on the possible tag values
    const value = props.defaultValue
      .map(tag => {
        const availableTag = availableTags.find(tagGroup => tagGroup.tagTypeId === tag.tag.tagTypeRefId);
        const options = availableTag?.options ?? [];
        return options.find(groupTag => groupTag.value === tag.tag.tagRefId);
      });

    this.state = {
      availableTags,
      value: this.sortTags(value),
      preview: this.props.preview,
      errorMessage: null,
    };
  }

  componentDidMount() {
    if (this.ref && !this.ref.enablePreviewEdit) {
      this.ref.enablePreviewEdit = this.enablePreviewEdit;
      this.ref.disablePreviewEdit = this.disablePreviewEdit;
      this.ref.validateSelection = this.validateSelection;
    }
  }

  sortTags = (tags) => {
    return tags.sort((a, b) =>
        a.tagTypeId.localeCompare(b.tagTypeId) || a.label.localeCompare(b.label)
    );
  }

  onChange = (tags) => {
    if (tags === null) {
      tags = [];
    }

    tags = this.sortTags(tags);
    if (this.props.onChange) {
      this.props.onChange(this.getApiValue(tags));
    }

    this.setState({ value: tags }, this.validateSelection);
  }

  enablePreviewEdit = () => {
    if (this.props.preview && this.state.preview) {
      this.setState({ preview: false }, () => {
        if (this.selectRef && this.selectRef.current) {
          this.selectRef.current.focus();
        }
      });
    }
  }

  disablePreviewEdit = () => {
    if (this.props.preview && !this.state.preview && this.validateSelection()) {
      this.setState({ preview: true });
      if (this.props.onPreviewEditEnd) {
        this.props.onPreviewEditEnd(this.getApiValue(this.state.value));
      }
    }
  }

  getApiValue = (tags) => {
    return tags.map(tag => ({
      tagId: tag.value,
      tag: this.state.availableTags.find(tagR => tagR.tagRefId === tag.value),
    }));
  }

  validateSelection() {
    let errorMessage = null;

    if (this.state.value.length === 0) {
      errorMessage = 'Select at least one tag.';
    } // check for status

    if (errorMessage != this.state.errorMessage) {
      this.setState({ errorMessage });
    }

    return !errorMessage;
  }

  render() {
    const isDisable = this.props.disable || this.state.preview;

    return (
      <div
        className={
          'tagListEditor' +
          (this.state.preview ? ' tagListEditor-preview' : '') +
          (isDisable ? ' tagListEditor-disable' : '')
        }
        ref={e => this.ref = e}
      >
        <div className='formInputErrorTextHelper'>
          {this.state.errorMessage}
        </div>
        <Select
          className={"tagListEditorSelect" + (this.props.required && (!this.state.value || this.state.value.length === 0) ? ' is-invalid': ' is-valid')}
          classNamePrefix="react-select"
          value={this.state.value}
          options={this.state.availableTags}
          isMulti
          name="tags"
          searchable={true}
          isClearable={false}
          //isDisabled={this.props.disable || this.state.preview}
          //menuIsOpen={true}
          openMenuOnClick={!isDisable}
          isOptionDisabled={() => isDisable}
          backspaceRemovesValue={!isDisable}

          components={{
            DropdownIndicator: () => (this.state.preview ? null : <div className='tagSelectorIndicator'><i className='icon-more-little'></i></div>),
            IndicatorSeparator: () => null,
            ...(this.props.disable || this.state.preview ? { MultiValueRemove: () => null } : ({}))
          }}
          placeholder={this.props.disable ? '' : 'Add tag'}
          onChange={(tags) => this.onChange(tags)}
          ref={this.selectRef}

          formatGroupLabel={(tagGroup) =>
            <div className='tagGroup'>
              <i className={"icon-tag-" + tagGroup.tagTypeId} />
              {tagGroup.label}
              <span className='tagSelectorGroupCount'> ({tagGroup.options.length})</span>
            </div>
          }
          formatOptionLabel={(tag) => {
            let content = (
              <span className='tagLabel'>
                <i className={"icon-tag-" + tag.tagTypeId} />
                {tag.label}
              </span>
            );

            if (this.state.preview) {
              return (<a className='tagListEditorOptionLabel' href={'/project/search?textSearch=&tagId=' + encodeURIComponent(tag.value)} alt={tag.label} title={'search for this tag'}>{content}</a>);
            }
            return (<span className='tagListEditorOptionLabel'>{content}</span>);
          }}
        />
      </div>
    );
  }
}

export default TagListEditor;
